export default "__VITE_ASSET__XpZpTUgj__"